goog.provide("shadow.js.shim.module$ol$layer$Group");
goog.provide("module$shadow_js_shim_module$ol$layer$Group");
shadow.js.shim.module$ol$layer$Group = shadow.js.nativeProvides["ol/layer/Group"] = shadow$bridge("ol/layer/Group");
module$shadow_js_shim_module$ol$layer$Group.default = shadow.js.shim.module$ol$layer$Group;
